import React from "react";
import { Download, Share2 } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";

interface HeaderSectionProps {
  profileData: TransformedProfileData;
  onDownloadVCard: () => void;
  onShare: () => void;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  profileData,
  onDownloadVCard,
  onShare,
}) => {
  const initial = profileData?.personalInfo.name?.[0] ?? "U";

  return (
    <header className="w-full">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 sm:py-4 md:px-6 lg:px-8">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0 flex-1">
          <div className="relative h-9 w-9 sm:h-10 sm:w-10 overflow-hidden rounded-full border-2 border-white/20 dark:border-gray-700/50 shadow-lg flex-shrink-0 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900">
            <img
              src={profileData.personalInfo.avatar}
              alt={profileData.personalInfo.name}
              className="h-full w-full object-cover"
              onError={(e) => {
                // Fallback to initial if image fails to load
                e.currentTarget.style.display = "none";
                e.currentTarget.nextElementSibling?.classList.remove("hidden");
              }}
            />
            {/* Fallback initial - hidden by default, shown on image error */}
            <div className="absolute inset-0 hidden place-items-center bg-gradient-to-br from-blue-500 to-purple-600 text-sm sm:text-base font-bold text-white">
              {initial}
            </div>
          </div>
          <span className="text-sm sm:text-base font-medium bg-gradient-to-r from-blue-900 via-gray-900 to-purple-900 dark:from-blue-100 dark:via-white dark:to-purple-100 bg-clip-text text-transparent truncate">
            {profileData.personalInfo.name}
          </span>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <button
            onClick={onDownloadVCard}
            className="shine-button inline-flex items-center gap-1 sm:gap-2 rounded-full border border-blue-200/50 dark:border-blue-800/50 bg-gradient-to-r from-blue-500/10 to-purple-500/10 dark:from-blue-500/20 dark:to-purple-500/20 px-3 py-2 sm:px-4 sm:py-2 text-sm font-medium text-blue-700 dark:text-blue-300 shadow-sm transition-all duration-300 hover:from-blue-500/20 hover:to-purple-500/20 hover:shadow-md hover:scale-105 dark:hover:from-blue-500/30 dark:hover:to-purple-500/30"
          >
            <Download className="h-4 w-4 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">Save contact</span>
            <span className="sm:hidden">Save</span>
          </button>
          <button
            onClick={onShare}
            className="inline-flex items-center gap-1 sm:gap-2 rounded-full border border-purple-200/50 dark:border-purple-800/50 bg-gradient-to-r from-purple-500/10 to-blue-500/10 dark:from-purple-500/20 dark:to-blue-500/20 px-3 py-2 sm:px-4 sm:py-2 text-sm font-medium text-purple-700 dark:text-purple-300 shadow-sm transition-all duration-300 hover:from-purple-500/20 hover:to-blue-500/20 hover:shadow-md hover:scale-105 dark:hover:from-purple-500/30 dark:hover:to-blue-500/30"
          >
            <Share2 className="h-4 w-4 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">Share</span>
          </button>
        </div>
      </div>
    </header>
  );
};
